import React, { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import useAuth from "../Auth/useAuth";
const StudentVerification = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [studentIdNumber, setStudentIdNumber] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [list, setList] = useState([]);
  const [verifiedList, setVerifiedList] = useState([]);

  const search = () => {
    const q = query(
      collection(db, "admissionStudentList"),
      where("studentIdNumber", "==", studentIdNumber)
    );
    onSnapshot(q, (querySnapshot) => {
      let studentArray = [];
      querySnapshot.forEach((doc) => {
        studentArray.push({ id: doc.id, ...doc.data() });
      });
      setList(studentArray);
    });
  };

  const handleOnSubmit = async () => {
    await addDoc(collection(db, "studentUserTypeVerify"), {
      studentIdNumber,
      email: user.email,
    }).then(() => {
      window.location.reload(false);
    });
  };

  const buttonHandle = () => {
    setOpenModal(true);
    search();
  };

  useEffect(() => {
    const q = query(
      collection(db, "studentUserTypeVerify"),
      where("studentIdNumber", "==", studentIdNumber)
    );
    onSnapshot(q, (querySnapshot) => {
      let verifiedArray = [];
      querySnapshot.forEach((doc) => {
        verifiedArray.push({ id: doc.id, ...doc.data() });
      });
      setVerifiedList(verifiedArray);
    });
  }, [studentIdNumber]);

  const handleOnNavegateToHomePage = () => {
    logout();
    navigate("/home");
  };

  return (
    <div className="font-bold text-lg">
      <div className="sm:ml-48 mt-10 p-5  text-black-500 text-lg font-bold">
        <div className=" mb-5">
          <div className="mb-4">
            <label className="block text-grey-darker text-xl font-bold mb-2">
              Registration No.
            </label>
            <div className="flex">
              <input
                className=" border rounded w-96 py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Registration No."
                value={studentIdNumber}
                onChange={(e) => {
                  setStudentIdNumber(e.target.value);
                }}
              />
              <button
                className="bg-blue-500 px-6 ml-4 rounded-md text-lg text-white font-bold"
                onClick={buttonHandle}
              >
                Search
              </button>
            </div>
          </div>
          <div className="mx-auto text-blue-500">
            <button  onClick={handleOnNavegateToHomePage}>Go to Home</button>
          </div>
        </div>
      </div>

      {openModal && (
        <div className="flex justify-center">
          <div className="mx-4 w-96 px-4 py-10 pt-4 rounded-xl space-y-4 mb-10 shadow-lg border shadow-gray-500">
            <div className="pt-2">
              <h1 className="text-4xl font-bold">Registration Data</h1>
              <div className="border-b-4 mt-4"></div>
              <div className="justify-center">
                <div className="">
                  {list.map((item, index) => (
                    <div className="mt-5" key={index}>
                      <div className="">
                        <div className="hidden">
                          <div className="font-bold text-lg">S.NO.</div>
                          <div className="ml-10 font-bold text-lg">
                            {++index}
                          </div>
                        </div>
                        <div className="flex">
                          <div className="ml-5 font-bold text-lg">Name</div>
                          <div className="ml-10 font-semibold text-lg">
                            {item.fullName}
                          </div>
                        </div>
                      </div>

                
                      <div className="grid grid-rows-2 ">
                        <div className="flex">
                          <div className="ml-5 font-bold text-lg">Email</div>
                          <div className="ml-10 font-semibold text-lg">
                            {user.email}
                          </div>
                        </div>
                        <div className="flex">
                          <div className="ml-5 font-bold text-lg">
                            Registration No.
                          </div>
                          <div className="ml-10 font-semibold text-lg">
                            {item.studentIdNumber}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {verifiedList[0]?.studentIdNumber !== studentIdNumber &&
                list.length === 1 &&
                studentIdNumber === list[0]?.studentIdNumber ? (
                  <div className="mx-auto text-center mt-10">
                    <button
                      className="bg-blue-900 p-1 px-6 text-2xl text-white font-semibold rounded-lg"
                      onClick={handleOnSubmit}
                    >
                      APPLY
                    </button>
                  </div>
                ) : verifiedList[0]?.studentIdNumber !== studentIdNumber &&
                  list.length === 0 ? (
                  <div className="text-center mt-4">Please Enter Valid Id</div>
                ) : (
                  <div className="text-center mt-4">Cannot Apply</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentVerification;
